'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

export default function MobileMenuToggle() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        className="md:hidden p-2 rounded-lg text-white hover:bg-white/10 transition-colors"
        onClick={() => setOpen(!open)}
        aria-label="Toggle menu"
      >
        {open ? <XMarkIcon className="w-6 h-6" /> : <Bars3Icon className="w-6 h-6" />}
      </button>
      {open && (
        <div className="absolute top-16 left-0 right-0 bg-primary border-b border-white/10 md:hidden z-50">
          <div className="px-6 py-4 flex flex-col gap-1">
            {[
              { label: 'Home', href: '/' },
              { label: 'Features', href: '#features' },
              { label: 'Pricing', href: '#pricing' },
              { label: 'FAQ', href: '#faq' },
              { label: 'For Businesses', href: '/b2b-dashboard' },
              { label: 'Login', href: '/login' },
              { label: 'Sign Up Free', href: '/register' },
            ]?.map((item) => (
              <Link
                key={`mobile-nav-${item?.label}`}
                href={item?.href}
                className="px-3 py-2.5 text-sm font-medium text-slate-300 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
                onClick={() => setOpen(false)}
              >
                {item?.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </>
  );
}